<template>
  <div>
    <transition name="slide-up">
      <div v-if="showFooter" class="wrapper">
        <div class="indicator">
          <TargetGroupIndicator v-if="hasUpdates && isCustomLocationGroup" />
          <div v-if="notShowPointList" class="red--text">
            地図の範囲内に地点数が100地点以上あるため、表示できません。ズームをして、表示エリアを狭めて下さい。
          </div>
        </div>
        <SaveOrCancelPointList
          v-if="canEdit && hasUpdates && isCustomLocationGroup"
          class="save-or-cancel"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import TargetGroupIndicator from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/footer/TargetGroupIndicator'
import SaveOrCancelPointList from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/footer/SaveOrCancelPointList'
import RouteHelper from '@/mixins/RouteHelper'
import { getters } from '@/vuex/modules/pointGroupOperation/constants'
import { locationGroupType } from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants'

export default {
  name: 'MapFooter',
  components: {
    TargetGroupIndicator,
    SaveOrCancelPointList,
  },
  mixins: [RouteHelper],
  computed: {
    isCustomLocationGroup() {
      return (
        this.$store.getters[getters.targetGroup].locationType ===
        locationGroupType.CUSTOM_LOCATION
      )
    },
    isEditingPoiCategory() {
      return this.$store.getters[getters.isEditingPoiCategory]
    },
    canEdit() {
      return !this.underSystemOwnerPage
    },
    hasUpdates() {
      return this.$store.getters[getters.targetGroupHasUpdates]
    },
    notShowPointList() {
      return this.$store.getters[getters.pointListInFrameCount] >= 100
    },
    showFooter() {
      return (
        (!this.isEditingPoiCategory && this.notShowPointList) ||
        (this.hasUpdates && this.isCustomLocationGroup)
      )
    },
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #cce5ff;
  padding: 10px 20px;
  min-height: 50px;
  z-index: 100;
}
.indicator {
  flex: 1;
  min-width: 0; // text-overflow を効かせるためのハック
}
.save-or-cancel {
  width: 240px;
  margin-left: 20px;
}
.slide-up-enter {
  bottom: -60px;
}
.slide-up-enter-active,
.slide-up-leave-active {
  transition: bottom 0.3s;
}
.slide-up-enter-to {
  bottom: 0;
}
.slide-up-leave {
  bottom: 0;
}
.slide-up-leave-to {
  bottom: -60px;
}
</style>
